import { ConfigurationChangelogListQuery } from '@rossum/api-client/configurationChangelog';
import { ConfigurationChangelogQuery } from './useConfigurationChangelogFilterSettings';

/**
 * Maps the page's filter state to the API query. The API only knows object
 * types and IDs; the object pickers (Extension, Queue) are shortcuts that fill
 * both, so a picker wins over the generic object type and ID filters.
 */
export const toConfigurationChangelogListQuery = ({
  search: _search,
  hook,
  queue,
  objectType,
  objectId,
  ...rest
}: ConfigurationChangelogQuery): ConfigurationChangelogListQuery => {
  if (hook?.length) {
    return { ...rest, objectType: ['hook'], objectId: hook };
  }

  if (queue?.length) {
    return { ...rest, objectType: ['queue'], objectId: queue };
  }

  return { ...rest, objectType, objectId };
};
